import type { IconData } from '@stacksjs/iconify-core'

export const levelDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m171.313 348.686l-22.626 22.628L272 494.627l123.313-123.313l-22.626-22.628L288 433.373V96H72v32h184v305.373z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default levelDown
